/*
  ============================================================
  interface.js — comportamento da interface da loja
  ============================================================

  O QUE FAZ:
  Trata do que abre e fecha: menu mobile, gaveta do carrinho,
  painel de pesquisa e seletor de quantidade.

  O QUE NAO FAZ:
  Nao fala com o carrinho da Shopify — isso e o carrinho.js.
  Aqui so se mexe no DOM.

  PRINCIPIOS QUE ESTE FICHEIRO SEGUE:

  1. A loja funciona sem JavaScript. O botao do carrinho e um <a>
     que aponta para /cart; se este ficheiro nao carregar, clicar
     leva a pagina do carrinho em vez de abrir a gaveta. Nada
     depende de JS para ser alcancavel.

  2. Quem abre um painel tem de conseguir sair dele. Todos fecham
     com Escape e devolvem o foco ao botao que os abriu — sem isso,
     quem navega por teclado fica preso no fim da pagina.

  3. Enquanto um painel esta aberto o fundo nao rola. Sem isto, no
     telemovel, arrastar dentro da gaveta arrasta a pagina por
     baixo e perde-se o sitio onde se estava.
*/
(function () {
  'use strict';

  var corpo = document.body;

  /* ----------------------------------------------------------
     Camadas: menu mobile e gaveta do carrinho
     ---------------------------------------------------------- */

  var camadaAberta = null;
  var focoAnterior = null;

  function bloquearFundo(bloquear) {
    corpo.classList.toggle('esta-bloqueado', bloquear);
  }

  /* O veu e so para a gaveta do carrinho.
     -------------------------------------------------------------
     A gaveta e um painel lateral: precisa de escurecer o resto da
     pagina e de dar um sitio onde tocar para fechar. O menu mobile
     nao e nada disso — ocupa o ecra todo, e opaco, e tem o X do
     cabecalho para fechar.

     E nao era so inutil: era o que partia o menu. O veu esta a
     z-index 99 e o painel do menu a 65, portanto o veu ficava POR
     CIMA do menu. Como e quase invisivel contra um painel escuro,
     o menu parecia normal — mas todos os toques aterravam no veu, e
     o veu fecha a camada. Carregar em "Catalogo" fechava o menu e
     ficava-se na mesma pagina. */
  function abrirCamada(nome, elemento, gatilho, comVeu) {
    if (camadaAberta) fecharCamada();

    camadaAberta = { nome: nome, elemento: elemento, gatilho: gatilho };
    focoAnterior = gatilho || document.activeElement;

    elemento.classList.add('esta-aberto');
    if (gatilho) gatilho.setAttribute('aria-expanded', 'true');
    bloquearFundo(true);

    if (comVeu) {
      var veu = document.querySelector('[data-veu]');
      if (veu) veu.classList.add('esta-aberto');
    }

    /* O foco so pode ir para dentro do painel depois de a transicao
       de visibility acabar: enquanto ele esta visibility:hidden os
       elementos nao sao focaveis e o .focus() nao faz nada. */
    var focarPrimeiro = function () {
      var primeiro = elemento.querySelector(
        'button:not([disabled]), [href], input:not([disabled]), select, textarea, [tabindex]:not([tabindex="-1"])'
      );
      if (primeiro) primeiro.focus();
    };

    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      focarPrimeiro();
    } else {
      elemento.addEventListener('transitionend', focarPrimeiro, { once: true });
      // Rede de seguranca: se a transicao nao disparar, foca a seguir
      setTimeout(focarPrimeiro, 400);
    }
  }

  function fecharCamada() {
    if (!camadaAberta) return;

    var elemento = camadaAberta.elemento;
    var gatilho = camadaAberta.gatilho;

    elemento.classList.remove('esta-aberto');
    if (gatilho) gatilho.setAttribute('aria-expanded', 'false');

    var veu = document.querySelector('[data-veu]');
    if (veu) veu.classList.remove('esta-aberto');

    bloquearFundo(false);

    // Devolve o foco a quem abriu, para nao perder o sitio
    if (focoAnterior && typeof focoAnterior.focus === 'function') {
      focoAnterior.focus();
    }

    camadaAberta = null;
    focoAnterior = null;
  }

  window.bcsFecharCamada = fecharCamada;

  window.bcsAbrirCarrinho = function () {
    var gaveta = document.querySelector('[data-gaveta-carrinho]');
    if (!gaveta) return;
    var botao = document.querySelector('[data-abrir-carrinho]');
    abrirCamada('carrinho', gaveta, botao, true);
  };

  /* ----------------------------------------------------------
     Prender o foco dentro do painel aberto
     ------------------------------------------------------------
     Sem isto, carregar em Tab dentro da gaveta leva o foco para
     os links da pagina por tras, que estao escondidos por um veu:
     ve-se o contorno de foco a saltar para sitio nenhum.
     ---------------------------------------------------------- */

  function prenderFoco(evento) {
    if (!camadaAberta || evento.key !== 'Tab') return;

    var focaveis = camadaAberta.elemento.querySelectorAll(
      'button:not([disabled]), [href], input:not([disabled]), select, textarea, [tabindex]:not([tabindex="-1"])'
    );
    if (!focaveis.length) return;

    var primeiro = focaveis[0];
    var ultimo = focaveis[focaveis.length - 1];

    if (evento.shiftKey && document.activeElement === primeiro) {
      evento.preventDefault();
      ultimo.focus();
    } else if (!evento.shiftKey && document.activeElement === ultimo) {
      evento.preventDefault();
      primeiro.focus();
    }
  }

  /* ----------------------------------------------------------
     Ligacoes
     ---------------------------------------------------------- */

  document.addEventListener('click', function (evento) {
    // Menu mobile
    var abrirMenu = evento.target.closest('[data-abrir-menu]');
    if (abrirMenu) {
      var menu = document.querySelector('[data-menu-mobile]');
      if (!menu) return;
      if (camadaAberta && camadaAberta.nome === 'menu') {
        fecharCamada();
      } else {
        abrirCamada('menu', menu, abrirMenu, false);
      }
      return;
    }

    // Gaveta do carrinho — so intercepta se o JS estiver mesmo a
    // funcionar; caso contrario o <a href="/cart"> segue o seu caminho
    var abrirCarrinho = evento.target.closest('[data-abrir-carrinho]');
    if (abrirCarrinho && document.querySelector('[data-gaveta-carrinho]')) {
      evento.preventDefault();
      window.bcsAbrirCarrinho();
      return;
    }

    if (evento.target.closest('[data-fechar-camada]') || evento.target.closest('[data-veu]')) {
      evento.preventDefault();
      fecharCamada();
      return;
    }

    // Fechar o painel de pesquisa ao clicar fora dele
    var pesquisa = document.querySelector('[data-pesquisa][open]');
    if (pesquisa && !evento.target.closest('[data-pesquisa]')) {
      pesquisa.removeAttribute('open');
    }
  });

  document.addEventListener('keydown', function (evento) {
    if (evento.key === 'Escape') {
      if (camadaAberta) {
        fecharCamada();
        return;
      }
      var pesquisa = document.querySelector('[data-pesquisa][open]');
      if (pesquisa) {
        pesquisa.removeAttribute('open');
        var resumo = pesquisa.querySelector('summary');
        if (resumo) resumo.focus();
      }
    }
    prenderFoco(evento);
  });

  // Ao abrir a pesquisa, o cursor vai direto para o campo
  document.addEventListener('toggle', function (evento) {
    var alvo = evento.target;
    if (alvo.matches && alvo.matches('[data-pesquisa]') && alvo.open) {
      var campo = alvo.querySelector('input[type="search"]');
      if (campo) campo.focus();
    }
  }, true);

  /* ----------------------------------------------------------
     Seletor de quantidade
     ---------------------------------------------------------- */

  document.addEventListener('click', function (evento) {
    var botao = evento.target.closest('.quantity__button');
    if (!botao) return;

    var caixa = botao.closest('.quantity-selector');
    var campo = caixa && caixa.querySelector('.quantity__input');
    if (!campo) return;

    var valor = parseInt(campo.value, 10) || 1;
    var minimo = parseInt(campo.getAttribute('min'), 10) || 1;
    var maximo = parseInt(campo.getAttribute('max'), 10) || Infinity;

    valor = botao.name === 'plus' ? valor + 1 : valor - 1;
    campo.value = Math.min(Math.max(valor, minimo), maximo);

    // 'change' para que quem escuta o campo (carrinho) reaja
    campo.dispatchEvent(new Event('change', { bubbles: true }));
  });
})();
